import { api } from '@bilibili-maoer/web-utils';

var DEFAULT_AVATAR = "".concat(api.MISSEVAN_CDN_PREFIX_URL, "/avatars/icon01.png");

export { DEFAULT_AVATAR };
